import { render } from "./RevisionStockCrossDockingComponent.vue?vue&type=template&id=791b720c&scoped=true"
import script from "./RevisionStockCrossDockingComponent.vue?vue&type=script&lang=js"
export * from "./RevisionStockCrossDockingComponent.vue?vue&type=script&lang=js"

import "./RevisionStockCrossDockingComponent.vue?vue&type=style&index=0&id=791b720c&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791b720c"]])

export default __exports__